import { ArtifactsViewerData } from "@/hooks/useArtifactsViewerData";
import { RtcTask } from "@/store/thread";
import { convertFilePathToUrl } from "@/util/convertFilePathToUrl";
import { useMemo } from "react";
import { AssetItem } from "./shared/AssetItem";

import { SelectedAsset } from "@/store/assetsExplorer";

interface ReferenceTabProps {
  data: ArtifactsViewerData["referenceImage"]["data"];
  rtcTasks: RtcTask[];
  onSelect: (asset: SelectedAsset) => void;
}

export function ReferenceTab(props: ReferenceTabProps) {
  const { data, onSelect } = props;

  const references = useMemo(() => {
    return data.images
      .map((image, index) => {
        if (!image.file_path) {
          return null;
        }
        const url = convertFilePathToUrl(image.file_path, { level: "medium" });
        return {
          index,
          path: image.file_path,
          url,
          previewSrc: url,
          prompt: image.prompt,
          caption: image.caption,
          id: image.id,
          type: image.type,
        };
      })
      .filter((item): item is NonNullable<typeof item> => item !== null);
  }, [data.images]);

  if (references.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-text-tertiary">
        No reference images available
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {references.map((reference, index) => (
        <AssetItem
          key={`reference_${reference.path}-${index}`}
          src={reference.url}
          previewSrc={reference.previewSrc}
          alt={reference.id}
          mediaType="image"
          bottomLabel={reference.id}
          onClick={() => onSelect({ type: "reference", path: reference.path })}
        />
      ))}
    </div>
  );
}
